import { token } from '@atlaskit/tokens';

import {
	HUB_PRIMARY_COLOR_CSS_VAR,
	HUB_PRIMARY_TEXT_COLOR_CSS_VAR,
} from '../../constants';

export type HubDefaultParameters = {
	backgroundColor: string;
	textColor: string;
};

export const getHubDefaultParameters = (): HubDefaultParameters => {
	return {
		backgroundColor: `var(${HUB_PRIMARY_COLOR_CSS_VAR}, ${token('color.background.accent.gray.subtler')})`,
		textColor: `var(${HUB_PRIMARY_TEXT_COLOR_CSS_VAR}, ${token('color.text')})`,
	};
};
